<div class="page-content pb-0" style="margin-top: 0">

    <div class="splide"
         data-id="registration-splider">
        <div class="splide_slider">
            <div class="splide__track">
                <div class="splide__list">
                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center text-center">
                                <h1 class="mb-0 text-white">Herzlich Willkommen bei</h1>
                                <h1 class="pb-4r"><img src="assets/images/youtine-logo-white.svg" class="mx-auto" width="240"></h1>
                                <h4 class="mb-4 pb-4 text-white">Die App zur Realisierung deiner Ziele.</h4>
                                <p class="mt-3 text-white">
                                    Du hast bereits einen Account?
                                </p>
                                <p class="mt-1 text-center">
                                    <a href="/login">Hier geht's zum Login <i class="fa-solid fa-arrow-right"></i></a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center">
                                <p>
                                    <img src="assets/images/Tagesrhythmus-cropped.png" class="mx-auto" style="width: max(40%, 300px)">
                                </p>
                                <div class="card card-style mt-3" style="background-color: white!important;">
                                    <div class="content">
                                        <p class="mb-n1 color-highlight font-600">Deine</p>
                                        <h1>ROUTINE</h1>
                                        <p class="mb-2 font-weight-bolder">
                                            Stelle dir nun eine individuelle Routine zusammen. Zur Unterstützung des Einstiegs haben wir einige Beispiele vorbereitet, aus denen du auswählen kannst.
                                        </p>
                                        <p class="mb-2 font-weight-bolder">
                                            Markiere die Punkte, die zu deinem Alltag passen, und klicke auf „WEITER". Wir starten mit der Tagesroutine, wähle die Punkte so, dass du sie JEDEN Tag umsetzen kannst.
                                        </p>
                                        <p class="font-weight-bolder">
                                            Los geht's!
                                        </p>
                                    </div>
                                </div>
                                <div style="height: 90px; min-height: 90px">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <h4 class="mb-4 text-white">
                                            Was möchtest du zu deiner täglichen Morgenroutine hinzufügen?
                                        </h4>
                                        <% for ( let ri = 0; ri < dailyMorningRoutines.length; ri++ ) { %>
                                            <routine-selection-item name="<%= dailyMorningRoutines[ ri ].name %>"
                                                                    goal="<%= dailyMorningRoutines[ ri ].goal %>"
                                                                    icon="<%= dailyMorningRoutines[ ri ].hasOwnProperty( 'icon' ) ? dailyMorningRoutines[ ri ].icon : '' %>"
                                                                    category-id="<%= dailyMorningRoutines[ ri ].categoryId %>"
                                                                    routine-id="<%= dailyMorningRoutines[ ri ].id %>"></routine-selection-item>
                                        <% }    %>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <h4 class="mb-4 text-white">
                                            Wie soll deine Mittagsroutine aussehen?
                                        </h4>
                                        <% for ( let ri = 0; ri < dailyMiddayRoutines.length; ri++ ) { %>
                                        <routine-selection-item name="<%= dailyMiddayRoutines[ ri ].name %>"
                                                                goal="<%= dailyMiddayRoutines[ ri ].goal %>"
                                                                icon="<%= dailyMiddayRoutines[ ri ].hasOwnProperty( 'icon' ) ? dailyMiddayRoutines[ ri ].icon : '' %>"
                                                                category-id="<%= dailyMiddayRoutines[ ri ].categoryId %>"
                                                                routine-id="<%= dailyMiddayRoutines[ ri ].id %>"></routine-selection-item>
                                        <% }    %>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <h4 class="mb-4 text-white">
                                            Welche Punkte sollen in deiner Abendroutine sein?
                                        </h4>
                                        <% for ( let ri = 0; ri < dailyEveningRoutines.length; ri++ ) { %>
                                            <routine-selection-item name="<%= dailyEveningRoutines[ ri ].name %>"
                                                                    goal="<%= dailyEveningRoutines[ ri ].goal %>"
                                                                    icon="<%= dailyEveningRoutines[ ri ].hasOwnProperty( 'icon' ) ? dailyEveningRoutines[ ri ].icon : '' %>"
                                                                    category-id="<%= dailyEveningRoutines[ ri ].categoryId %>"
                                                                    routine-id="<%= dailyEveningRoutines[ ri ].id %>"></routine-selection-item>
                                        <% }    %>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <h4 class="mb-5 text-white">
                                            Möchtest du noch etwas zu deiner täglichen Routine hinzufügen?
                                        </h4>
                                        <routine-selection-individual category-id="daily-goal"
                                                                      icons="hearts-suit,bathtub,fruit-crate,lotus-flower,medicine,home-3"
                                                                      goal="daily"
                                                                      routine-id="0"
                                                                      weekly-frequence="7"></routine-selection-individual>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <p class="mb-1 text-white font-600 text-uppercase">Tagesziele:</p>
                                        <% for ( let ri = 0; ri < dailyGoalRoutines.length; ri++ ) {    %>
                                            <routine-dynamic question="<%= dailyGoalRoutines[ ri ].question %>"
                                                             goal="<%= dailyGoalRoutines[ ri ].goal %>"
                                                             name="<%= dailyGoalRoutines[ ri ].name %>"
                                                             routine-id="<%= dailyGoalRoutines[ ri ].id %>"
                                                             weekly-frequence="7"
                                                             category-id="<%= dailyGoalRoutines[ ri ].categoryId %>"
                                                             <%= dailyGoalRoutines[ ri ].icon !== null ? 'icon=' + dailyGoalRoutines[ ri ].icon  : '' %>
                                                             options='<%= JSON.stringify( dailyGoalRoutines[ ri ].customValues ) %>'></routine-dynamic>
                                        <% }    %>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <p class="mb-1 text-white font-600 text-uppercase">Wochenziele:</p>
                                        <h4 class="mb-4 text-white">
                                            Wie viel Sport möchtest du pro Woche machen?
                                        </h4>
                                        <% for ( let ri = 0; ri < weeklySportRoutines.length; ri++ ) { %>
                                        <routine-selection-item name="<%= weeklySportRoutines[ ri ].name %>"
                                                                icon="<%= weeklySportRoutines[ ri ].hasOwnProperty( 'icon' ) ? weeklySportRoutines[ ri ].icon : '' %>"
                                                                category-id="<%= weeklySportRoutines[ ri ].categoryId %>"
                                                                goal="<%= weeklySportRoutines[ ri ].goal %>"
                                                                custom-weekly-frequencies="1;2;3;4;5;6;7"
                                                                routine-id="<%= weeklySportRoutines[ ri ].id %>"></routine-selection-item>
                                        <% }    %>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <div class="row">
                                            <div class="col-12">
                                                <h4 class="text-white mb-4">
                                                    Möchtest du noch eine Sportart hinzufügen?
                                                </h4>
                                            </div>
                                            <routine-selection-individual category-id="weekly-goal-sports"
                                                                          weekly-frequence="0"
                                                                          routine-id="0"
                                                                          goal="weekly"
                                                                          icons="water-aerobics,basketball-player,volleyball,dumbbell,dancer,run-shoes"></routine-selection-individual>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <p class="mb-1 text-white font-600 text-uppercase">Wochenziele:</p>
                                        <h4 class="mb-4 text-white">
                                           Wie häufig möchtest du in der Woche etwas maximal oder minimal konsumieren?
                                        </h4>
                                        <% for ( let ri = 0; ri < weeklyConsumeRoutines.length; ri++ ) { %>
                                            <routine-selection-item name="<%= weeklyConsumeRoutines[ ri ].name %>"
                                                                    goal="<%= weeklyConsumeRoutines[ ri ].goal %>"
                                                                    icon="<%= weeklyConsumeRoutines[ ri ].hasOwnProperty( 'icon' ) ? weeklyConsumeRoutines[ ri ].icon : '' %>"
                                                                    category-id="<%= weeklyConsumeRoutines[ ri ].categoryId %>"
                                                                    custom-weekly-frequencies="1;2;3;4;5;6;7"
                                                                    routine-id="<%= weeklyConsumeRoutines[ ri ].id %>"></routine-selection-item>
                                        <% }    %>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center-top">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <p class="mb-1 text-white font-600 text-uppercase">Wochenziele:</p>
                                        <h4 class="mb-4 text-white">
                                            Was möchtest du für deine geistige Gesundheit tun?
                                        </h4>
                                        <% for ( let ri = 0; ri < weeklySpiritRoutines.length; ri++ ) { %>
                                            <routine-selection-item name="<%= weeklySpiritRoutines[ ri ].name %>"
                                                                    goal="<%= weeklySpiritRoutines[ ri ].goal %>"
                                                                    icon="<%= weeklySpiritRoutines[ ri ].hasOwnProperty( 'icon' ) ? weeklySpiritRoutines[ ri ].icon : '' %>"
                                                                    category-id="<%= weeklySpiritRoutines[ ri ].categoryId %>"
                                                                    custom-weekly-frequencies="1;2;3;4;5;6;7"
                                                                    routine-id="<%= weeklySpiritRoutines[ ri ].id %>"></routine-selection-item>
                                        <% }    %>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="splide__slide">
                        <div class="card rounded-0 mb-0" data-card-height="cover-full">
                            <div class="card-center">
                                <div class="card ms-0 me-0 rounded-0" style="background-color: transparent!important;">
                                    <div class="content">
                                        <h1 class="pb-4r"><img src="assets/images/youtine-logo-white.svg" class="mx-auto" width="180px"></h1>
                                        <h1 class="mb-4 text-white">Registration</h1>
                                        <form data-id="registration-form">
                                            <div class="input-style input-style-always-active no-borders has-icon validate-field mb-5 mt-4">
                                                <i class="fa fa-user"></i>
                                                <input type="text"
                                                       name="name"
                                                       class="form-control validate-name"
                                                       id="input-name"
                                                       minlength="2"
                                                       maxlength="32"
                                                       placeholder="Wie dürfen wir dich ansprechen?"
                                                       required>
                                                <label for="input-name" class="color-primary text-uppercase font-700 font-10">Spitzname</label>
                                                <i class="fa fa-times invalid color-red-dark"></i>
                                                <i class="fa fa-check valid color-green-dark"></i>
                                                <!--
                                                <em>(Pfichtfeld)</em>
                                                -->
                                                <div class="input-error color-red-dark">
                                                    Bitte Spitznamen mit mindestens 2 Zeichen eingeben.
                                                </div>
                                            </div>
                                            <div class="input-style input-style-always-active no-borders has-icon validate-field mb-5 mt-5">
                                                <i class="fa fa-envelope"></i>
                                                <input type="email"
                                                       name="email"
                                                       class="form-control validate-name"
                                                       id="input-email"
                                                       placeholder="Nenne uns deine E-Mail"
                                                       required>
                                                <label for="input-email" class="color-primary text-uppercase font-700 font-10">E-Mail</label>
                                                <i class="fa fa-times invalid color-red-dark"></i>
                                                <i class="fa fa-check valid color-green-dark"></i>
                                                <!--
                                                <em>(Pfichtfeld)</em>
                                                -->
                                                <div class="input-error color-red-dark">
                                                    Bitte gebe deine E-Mail Adresse ein.
                                                </div>
                                            </div>
                                            <div class="input-style input-style-always-active no-borders has-icon validate-field mb-5 mt-5">
                                                <i class="fa fa-lock"></i>
                                                <input type="password"
                                                       name="password"
                                                       class="form-control validate-password"
                                                       id="input-password"
                                                       minlength="6"
                                                       maxlength="32"
                                                       placeholder="Wähle ein sicheres Passwort"
                                                       required>
                                                <label for="input-password" class="color-primary text-uppercase font-700 font-10">Password</label>
                                                <i class="fa fa-times invalid color-red-dark"></i>
                                                <i class="fa fa-check valid color-green-dark"></i>
                                                <!--
                                                <em>(Pfichtfeld)</em>
                                                -->
                                                <div class="input-error color-red-dark">
                                                    Das Passwort muss mindestens aus 6 Zeichen bestehen.
                                                </div>
                                            </div>
                                            <div class="form-check icon-check " style="margin: 32px 0; padding: 0">
                                                <input class="form-check-input"
                                                       type="checkbox"
                                                       name="accept-terms"
                                                       id="accept-terms"
                                                       required>
                                                <label class="form-check-label text-white"
                                                       for="accept-terms">
                                                    Hiermit akzeptiere ich die <a href="https://www.youtine.de/agb" target="_blank">AGB</a> und die <a href="https://www.youtine.de/datenschutz" target="_blank">Datenschutzerklärung</a>.
                                                </label>
                                                <i class="icon-check-1 far fa-square text-white font-16" style="left: 0px!important;"></i>
                                                <i class="icon-check-2 far fa-check-square font-16 text-white" style="left: 0px!important;"></i>
                                                <div class="input-error color-red-dark">
                                                    Bitte akzeptiere unsere AGB und Datenschutzerklärung.
                                                </div>
                                            </div>
                                            <div class="clearfix"></div>
                                            <p style="text-align: center">
                                                <button data-id="btn-register"
                                                        type="button"
                                                        style="margin: auto"
                                                        class="btn btn-l mb-3 mt-1 rounded-xs text-uppercase font-700 btn-shadow-l bg-white text-primary">Registrieren</button>
                                            </p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="splide__slide">
                        <div class="card mb-0" data-card-height="cover-full">
                            <div class="card-center">
                                <div class="card card-style" style="background-color: white!important;">
                                    <div class="content">
                                        <p class="mb-n1 color-highlight font-600">Deine Registration war</p>
                                        <h1 class="text-uppercase">erfolgreich</h1>
                                        <p class="mb-2 font-weight-bolder">
                                            In den nächsten Minuten erhälst du eine E-Mail von uns. Bitte verifiziere deine Anmeldung, indem du auf den Bestätigungslink in der E-Mail klickst.
                                        </p>
                                        <p class="mb-2 font-weight-bolder">
                                            Solltest du keine E-Mail in deinem Posteingang vorfinden, schaue bitte in dem Spam-Ordner nach.
                                        </p>
                                        <p class="mt-1 text-center">
                                            <a href="/login">Zum Login <i class="fa-solid fa-arrow-right"></i></a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="splide-custom-pagination-top">
        <button class="btn btn-xl mb-3 rounded-xs text-uppercase font-700 shadow-s"
                style="padding-left: 12px!important;"
                data-type="btn-splide-prev">
            <i class="fa fa-chevron-left"></i>
        </button>
    </div>

    <div class="splide-custom-pagination-bottom">
        <button class="btn btn-xl mb-3 btn-full rounded-xl text-uppercase font-700 btn-shadow-l bg-white text-primary"
                style="width: 80%; margin: auto"
                data-type="btn-splide-next">
            WEITER
        </button>
    </div>

    <!-- Page content ends here-->



</div>
